<!--
  Ficha del cliente (rediseño 2026-10-05): el establecimiento es lo central y va a
  la vista; los datos del cliente, contactos, contrato, objetivos y presupuestos se
  ven en una línea de resumen y se abren en un modal.
-->
@if (loading) {
  <app-spinner />
} @else if (cliente) {
  <div class="mb-6 flex flex-wrap items-center gap-x-3 gap-y-2 rounded-xl border border-gray-200 bg-white px-4 py-3 dark:border-gray-800 dark:bg-white/[0.03]">
    <a routerLink="/crm/clientes" title="Volver a Clientes"
      class="flex h-9 w-9 items-center justify-center rounded-lg text-gray-500 hover:bg-gray-100 hover:text-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.05] dark:hover:text-white/90">
      <mat-icon>arrow_back</mat-icon>
    </a>
    <h2 class="text-lg font-semibold text-gray-800 dark:text-white/90">{{ nombre }}</h2>
    @if (cliente.tipo_cliente) {
      <app-badge [startIcon]="'label'" [color]="cliente.tipo_cliente.activo ? 'primary' : 'light'">
        {{ cliente.tipo_cliente.nombre }}
      </app-badge>
    }
    <div class="ml-auto flex items-center gap-2">
      @if (permissionAuth.canView('prospectos') && cliente.conversiones.length) {
        <app-button [startIcon]="'visibility'" [variant]="'outline'" [size]="'sm'" (btnClick)="goToProspecto()">
          Ver prospecto original
        </app-button>
      }
      <app-icon-button *hasPermission="'clientes:edit'"
        [icon]="'edit'"
        [tooltip]="'Editar datos del cliente'"
        [ariaLabel]="'Editar datos del cliente'"
        (onClick)="editarCliente()"
      />
    </div>

    @let detalle = cliente.persona.persona_tipo_detalle;
    <dl class="grid w-full grid-cols-2 gap-x-6 gap-y-3 border-t border-gray-100 pt-3 text-sm sm:grid-cols-3 lg:grid-cols-5 dark:border-gray-800">
      <div>
        <dt class="text-xs text-gray-500 dark:text-gray-400">Tipo de persona</dt>
        <dd class="text-gray-800 dark:text-white/90">{{ cliente.persona.persona_tipo === 'J' ? 'Jurídica' : 'Física' }}</dd>
      </div>
      <div>
        <dt class="text-xs text-gray-500 dark:text-gray-400">Documento</dt>
        <dd class="text-gray-800 dark:text-white/90">{{ documento }}</dd>
      </div>
      <div>
        <dt class="text-xs text-gray-500 dark:text-gray-400">País</dt>
        <dd class="text-gray-800 dark:text-white/90">{{ pais }}</dd>
      </div>
      @if (cliente.persona.persona_tipo === 'J') {
        <div>
          <dt class="text-xs text-gray-500 dark:text-gray-400">Nombre comercial</dt>
          <dd class="text-gray-800 dark:text-white/90">{{ detalle.nombre_fantasia || '-' }}</dd>
        </div>
        <div>
          <dt class="text-xs text-gray-500 dark:text-gray-400">Fecha de constitución</dt>
          <dd class="text-gray-800 dark:text-white/90">{{ detalle.fecha_constitucion ? (detalle.fecha_constitucion | date:'dd/MM/yyyy') : '-' }}</dd>
        </div>
      }
    </dl>
  </div>

  <app-establecimientos [clienteId]="idCliente" />

  <div class="mt-6 divide-y divide-gray-100 overflow-hidden rounded-xl border border-gray-200 bg-white dark:divide-gray-800 dark:border-gray-800 dark:bg-white/[0.03]">
    <button type="button" class="flex w-full items-center gap-4 px-4 py-3 text-left text-sm transition-colors hover:bg-gray-50 dark:hover:bg-white/[0.02]" (click)="abrirSeccion('facturacion')">
      <span class="w-28 shrink-0 font-medium text-gray-800 dark:text-white/90">Facturación</span>
      <span class="min-w-0 flex-1 truncate text-gray-700 dark:text-gray-300">
        @if (cliente.persona.dato_facturacion; as f) {
          {{ f.razon_social }}{{ f.direccion_fiscal ? ' · ' + f.direccion_fiscal : '' }}{{ f.telefono ? ' · ' + f.telefono : '' }}{{ f.email ? ' · ' + f.email : '' }}
        } @else {
          <span class="text-gray-400 dark:text-gray-500">Sin datos de facturación</span>
        }
      </span>
      <mat-icon class="shrink-0 text-gray-400">chevron_right</mat-icon>
    </button>

    <div role="button" tabindex="0" class="flex w-full cursor-pointer items-center gap-4 px-4 py-3 text-left text-sm transition-colors hover:bg-gray-50 dark:hover:bg-white/[0.02]" (click)="abrirSeccion('contactos')" (keydown.enter)="abrirSeccion('contactos')">
      <span class="w-28 shrink-0 font-medium text-gray-800 dark:text-white/90">Contactos</span>
      <span class="min-w-0 flex-1 truncate text-gray-700 dark:text-gray-300">
        @if (contactoPrincipal; as c) {
          {{ c.nombre }} {{ c.apellido }} ({{ c.origen === 'A' ? c.establecimiento_tipo_contacto.nombre : (c.establecimiento?.nombre || 'Establecimiento') }}){{ c.celular ? ' · ' + c.celular : '' }}
          @if (totalContactos > 1) { · +{{ totalContactos - 1 }} }
        } @else {
          <span class="text-gray-400 dark:text-gray-500">Sin contactos</span>
        }
      </span>
      <button *hasPermission="'clientes:create'" type="button" title="Nuevo contacto" [attr.aria-label]="'Nuevo contacto'"
        class="flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-gray-500 hover:bg-gray-200 hover:text-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.08] dark:hover:text-white/90"
        (click)="abrirSeccion('contactos', true); $event.stopPropagation()" (keydown.enter)="$event.stopPropagation()">
        <mat-icon>add</mat-icon>
      </button>
      <mat-icon class="shrink-0 text-gray-400">chevron_right</mat-icon>
    </div>

    <div role="button" tabindex="0" class="flex w-full cursor-pointer items-center gap-4 px-4 py-3 text-left text-sm transition-colors hover:bg-gray-50 dark:hover:bg-white/[0.02]" (click)="abrirSeccion('contrato')" (keydown.enter)="abrirSeccion('contrato')">
      <span class="w-28 shrink-0 font-medium text-gray-800 dark:text-white/90">Contrato</span>
      <span class="min-w-0 flex-1 truncate text-gray-700 dark:text-gray-300">
        @if (contratoActivo; as c) {
          {{ c.nro_contrato ? 'N° ' + c.nro_contrato : 'Contrato #' + c.id }}
          @if (c.vencido) {
            · <span class="text-error-600 dark:text-error-400">vencido{{ c.fecha_fin ? ' el ' + (c.fecha_fin | date:'dd/MM/yyyy') : '' }}</span>
          } @else {
            · activo{{ c.fecha_fin ? ' hasta ' + (c.fecha_fin | date:'dd/MM/yyyy') : '' }}
          }
        } @else {
          <span class="text-gray-400 dark:text-gray-500">Sin contrato activo</span>
        }
      </span>
      <button *hasPermission="'clientes:create'" type="button" title="Nuevo contrato" [attr.aria-label]="'Nuevo contrato'"
        class="flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-gray-500 hover:bg-gray-200 hover:text-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.08] dark:hover:text-white/90"
        (click)="abrirSeccion('contrato', true); $event.stopPropagation()" (keydown.enter)="$event.stopPropagation()">
        <mat-icon>add</mat-icon>
      </button>
      <mat-icon class="shrink-0 text-gray-400">chevron_right</mat-icon>
    </div>

    <div role="button" tabindex="0" class="flex w-full cursor-pointer items-center gap-4 px-4 py-3 text-left text-sm transition-colors hover:bg-gray-50 dark:hover:bg-white/[0.02]" (click)="abrirSeccion('objetivos')" (keydown.enter)="abrirSeccion('objetivos')">
      <span class="w-28 shrink-0 font-medium text-gray-800 dark:text-white/90">Objetivos</span>
      <span class="min-w-0 flex-1 truncate text-gray-700 dark:text-gray-300">
        @if (objetivoVigente; as o) {
          {{ o.periodo?.nombre || 'Sin período' }}:
          {{ o.seguimiento?.preneces_positivas ?? 0 }} / {{ o.cantidad_preneces_proyectadas }} preñeces
          @if (o.seguimiento?.porcentaje !== null && o.seguimiento?.porcentaje !== undefined) { ({{ o.seguimiento?.porcentaje | number:'1.0-0' }} %) }
          @if (totalObjetivos > 1) { · +{{ totalObjetivos - 1 }} }
        } @else {
          <span class="text-gray-400 dark:text-gray-500">Sin objetivos</span>
        }
      </span>
      <button *hasPermission="'clientes:create'" type="button" title="Nuevo objetivo" [attr.aria-label]="'Nuevo objetivo'"
        class="flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-gray-500 hover:bg-gray-200 hover:text-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.08] dark:hover:text-white/90"
        (click)="abrirSeccion('objetivos', true); $event.stopPropagation()" (keydown.enter)="$event.stopPropagation()">
        <mat-icon>add</mat-icon>
      </button>
      <mat-icon class="shrink-0 text-gray-400">chevron_right</mat-icon>
    </div>

    <div role="button" tabindex="0" class="flex w-full cursor-pointer items-center gap-4 px-4 py-3 text-left text-sm transition-colors hover:bg-gray-50 dark:hover:bg-white/[0.02]" (click)="abrirSeccion('presupuestos')" (keydown.enter)="abrirSeccion('presupuestos')">
      <span class="w-28 shrink-0 font-medium text-gray-800 dark:text-white/90">Presupuestos</span>
      <span class="min-w-0 flex-1 truncate text-gray-700 dark:text-gray-300">
        @if (ultimoPresupuesto; as p) {
          {{ totalPresupuestos }}
          · último {{ p.fecha ? (p.fecha | date:'dd/MM/yyyy') : 'sin fecha' }}
          @if (p.monto !== null) { · {{ p.monto | number:'1.0-0' }} Gs }
        } @else {
          <span class="text-gray-400 dark:text-gray-500">Sin presupuestos</span>
        }
      </span>
      <button *hasPermission="'clientes:create'" type="button" title="Nuevo presupuesto" [attr.aria-label]="'Nuevo presupuesto'"
        class="flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-gray-500 hover:bg-gray-200 hover:text-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.08] dark:hover:text-white/90"
        (click)="abrirSeccion('presupuestos', true); $event.stopPropagation()" (keydown.enter)="$event.stopPropagation()">
        <mat-icon>add</mat-icon>
      </button>
      <mat-icon class="shrink-0 text-gray-400">chevron_right</mat-icon>
    </div>
  </div>
}
